import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';
import type { PublishPageAsBlogDialogProps } from '../src/types.ts';

export const PublishPageAsBlogDialog: LoadableType<PublishPageAsBlogDialogProps> =
	LoadableAfterPaint({
		loader: async () =>
			(
				await import(
					/* webpackChunkName: "loadable-PublishPageAsBlogDialog" */ '../src/PublishPageAsBlogDialog.tsx'
				)
			).PublishPageAsBlogDialog,
	});
